class RecommendedProducts extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  /**
   * Remove loaders.
   */
  removeLoaders() {
    // A small timeout is used to ensure the innerHTML operation has completed to ensure the animation works.
    setTimeout(() => {
      this.querySelectorAll('[data-loader]').forEach((loader) => {
        loader.ariaHidden = true;
      });

      // Also remove loading state from price elements that may have been replaced
      this.querySelectorAll('.price.loading').forEach((priceElement) => {
        priceElement.classList.remove('loading');
      });
    }, 50);
  }

  /**
   * Initialize the recommended products.
   */
  async init() {
    // Early return over a nested conditional (JS style rules). No URL means the
    // Liquid deliberately omitted it — there is nothing to fetch, so just reveal the
    // server-rendered backup products.
    if (!this.dataset?.url) {
      this.removeLoaders();
      return;
    }

    try {
      const response = await fetch(this.dataset.url);
      // A non-OK body carries no section markup, so fail here rather than letting a
      // null querySelector throw further down.
      if (!response.ok) throw new Error(`recommendations request failed: ${response.status}`);

      const text = await response.text();
      const parsed = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('[data-recommended-products]');
      // Null when the response isn't the expected section render. Keep the
      // server-rendered backup products rather than throwing.
      const html = parsed ? parsed.innerHTML : null;

      // Only replace content when these are real recommendations, not the fallback.
      if (html && !html.includes('data-fallback')) {
        this.innerHTML = html;
      }
    } catch (error) {
      console.error(error);
    } finally {
      // Always reveal the products — replaced or fallback, success or failure.
      this.removeLoaders();
    }
  }
}

customElements.define('recommended-products', RecommendedProducts);
